// This file is used to suppress console.error and console.warn messages that are not useful for debugging

const originalError = console.error;
const originalWarn = console.warn;

// Patterns to filter out
const suppressPatterns = [
  /AbortError/,
  /signal is aborted without reason/,
  /The user aborted a request/,
  /Request aborted/,
];

console.error = (...args: any[]) => {
  const message = args.join(' ');

  if (args[0] instanceof Error && args[0].name === 'AbortError') {
    return;
  }

  const shouldSuppress = suppressPatterns.some((pattern) =>
    pattern.test(message)
  );

  if (!shouldSuppress) {
    originalError.apply(console, args);
  }
};

console.warn = (...args: any[]) => {
  const message = args.join(' ');

  const shouldSuppress = suppressPatterns.some((pattern) =>
    pattern.test(message)
  );

  if (!shouldSuppress) {
    originalWarn.apply(console, args);
  }
};

export const restoreConsole = () => {
  console.error = originalError;
  console.warn = originalWarn;
};

export default {};
